import { THEMES, ThemeId, useTheme } from './ThemeProvider';

/** Vista previa de cada tema: 2 colores representativos (superficie + acento de marca). */
const SWATCHES: Record<ThemeId, { surface: string; brand: string }> = {
  claro: { surface: '#ffffff', brand: '#1fa66b' },
  sepia: { surface: '#fbf5e6', brand: '#8a6d3b' },
  oscuro: { surface: '#171c22', brand: '#34b077' },
  wms: { surface: '#141b28', brand: '#2f80ed' },
};

/** Selector de "Temas visuales" (Claro / Sepia / Oscuro / WMS) - se guarda por navegador. */
export function ThemeSwitcher() {
  const { theme, setTheme } = useTheme();

  return (
    <div className="flex flex-wrap gap-2">
      {THEMES.map((t) => {
        const active = theme === t.id;
        const swatch = SWATCHES[t.id];
        return (
          <button
            key={t.id}
            onClick={() => setTheme(t.id)}
            title={t.description}
            className={[
              'flex items-center gap-2 rounded-full border px-3 py-2 text-sm font-medium transition-colors',
              active ? 'border-brand-500 bg-brand-light text-brand-700' : 'border-ink-200 bg-surface text-ink-600 hover:bg-ink-50',
            ].join(' ')}
          >
            <span className="flex h-5 w-5 overflow-hidden rounded-full border border-ink-200" aria-hidden>
              <span className="h-full w-1/2" style={{ backgroundColor: swatch.surface }} />
              <span className="h-full w-1/2" style={{ backgroundColor: swatch.brand }} />
            </span>
            {t.label}
          </button>
        );
      })}
    </div>
  );
}
